import { Injectable, OnDestroy } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RoutesRecognized
} from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService implements OnDestroy {
  private navigating_to: string | undefined = undefined;
  private navigation_start_subject: Subject<NavigationStart> = new Subject<NavigationStart>();
  private navigation_end_subject: Subject<NavigationEnd> = new Subject<NavigationEnd>();
  private navigation_error_subject: Subject<NavigationError> = new Subject<NavigationError>();
  private subscriptions: Subscription = new Subscription();

  constructor(private router: Router) {}

  initialize(): void {
    this.subscriptions.add(
      this.router.events.subscribe((event: Event) => this.handleRouterEvent(event))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  isNavigating(): boolean {
    return this.navigating_to !== undefined;
  }

  navigatingTo(): string | undefined {
    return this.navigating_to;
  }

  get url(): string {
    return this.router.url;
  }

  get events(): Observable<Event> {
    return this.router.events;
  }

  get navigationStart(): Observable<NavigationStart> {
    return this.navigation_start_subject;
  }

  get navigationEnd(): Observable<NavigationEnd> {
    return this.navigation_end_subject;
  }

  get navigationError(): Observable<NavigationError> {
    return this.navigation_error_subject;
  }

  navigate(...args: Parameters<Router['navigate']>): Promise<boolean> {
    return this.router.navigate(...args);
  }

  private handleRouterEvent(event: Event): void {
    switch (true) {
      case event instanceof NavigationCancel:
        this.navigating_to = undefined;
        break;

      case event instanceof NavigationEnd:
        this.navigating_to = undefined;
        this.navigation_end_subject.next(event as NavigationEnd);
        break;

      case event instanceof NavigationError:
        this.navigating_to = undefined;
        this.navigation_error_subject.next(event as NavigationError);
        break;

      case event instanceof NavigationStart:
        this.navigating_to = (event as NavigationStart).url;
        this.navigation_start_subject.next(event as NavigationStart);
        break;

      case event instanceof RoutesRecognized:
        this.navigating_to = (event as RoutesRecognized).urlAfterRedirects;
        break;

      default:
        break;
    }
  }
}
